document.addEventListener('click', event => {
    const $target = event.target;
    const $menus = document.querySelectorAll('[data-nav-dropdown]');

    const clickedOutsideOf = ($target, $el, id) => {
        return !$target.closest(`#${id}`) && !$target.closest('.js-section-link') && $el.classList.contains('show')
    }

    const toggleCollapse = id => {
        const event = new CustomEvent('clickedOutsideNavigationDropdowns', { detail: id });
        document.dispatchEvent(event);
    }

    $menus.forEach($menu => {
        const id = $menu.getAttribute('id');

        if ($menu && clickedOutsideOf($target, $menu, id)) {
            toggleCollapse(id);
        }
    })
});
